import React, { useState, useEffect, useCallback } from "react"
import Select from "@material-ui/core/Select"
import { MenuItem } from "@material-ui/core"
import { ALLOWED_ROLES } from "../../../constants"

export default ({ company, user, onSelect, ...props }) => {
  const [auths, setAuths] = useState([])
  const [app, setApp] = useState("")

  const selectApp = useCallback(
    app => {
      setApp(app)
      onSelect && onSelect(app)
    },
    [onSelect],
  )
 
  useEffect(() => {
    const storedApp = localStorage.getItem("OMNI_SELECTED_APP")

    // auths from user
    const userAuths = (user.authorizations || [])
      .filter(el => {
        return company === el.companyName
      })
      .filter(auth => ALLOWED_ROLES.includes(auth.roleName.toLowerCase()))

    const userAuthIds = userAuths.map(auth => auth.app)

    // set options
    setAuths(userAuths)

    if (storedApp && userAuthIds.includes(storedApp)) {
      return selectApp(storedApp)
    }

    if (userAuths.length > 0) {
      const { app: userApp } = userAuths[0] || {}
      return selectApp(userApp)
    }
  }, [company])

  const authsIds = auths && auths.map(auth => auth.app)

  return (
    auths &&
    auths.length > 0 && (
      <Select
        {...props}
        value={authsIds.includes(app) ? app : authsIds[0]}
        style={{color:'#000000'}}
        onChange={evt => {
          const val = evt.target.value
          selectApp(val)
        }}
      >
        {auths &&
          auths.map((auth, i) => (
            <MenuItem key={i} value={auth.app}>
              {auth.appName}
            </MenuItem>
          ))}
      </Select>
    )
  )
}
